import p1 from '../resources/imgs/p1.webp'
import p2 from '../resources/imgs/p2.webp'
import p3 from '../resources/imgs/p3.webp'
import p4 from '../resources/imgs/p4.webp'
import p5 from '../resources/imgs/p5.webp'
import p6 from '../resources/imgs/p6.webp'

const Products = () => {
  return (
    <section className='products'>
      <div className='products-header'>
        <h2>Ukázkové produkty</h2>
        <h3>Pár příkladů naší práce</h3>
      </div>

      <div className='products-grid'>
        <img
          src={p1}
          alt='CNC obrábění tyčoviny z nerezi a duralu'
          className='products-item'
          loading='lazy'
        />
        <img
          src={p2}
          alt='Rotační CNC obrábění materiálů od průměru 6 mm do 75 mm'
          className='products-item'
          loading='lazy'
        />
        <img
          src={p3}
          alt='Výroba z přířezů do průměru 250 mm a obrábění odlitků'
          className='products-item'
          loading='lazy'
        />
        <img
          src={p4}
          alt='Přesné soustružení železa, mosazi a silonu'
          className='products-item'
          loading='lazy'
        />
        <img
          src={p5}
          alt='Kontrola kvality na optickém měřícím zařízení Keyence'
          className='products-item'
          loading='lazy'
        />
        <img
          src={p6}
          alt='Strojírenská výroba včetně laserového značení a povrchových úprav v Královéhradeckém kraji'
          className='products-item'
          loading='lazy'
        />
      </div>
    </section>
  )
}

export default Products
